import React, { useEffect } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import './ForbiddenPage.css';

const NotFound = () => {
  const navigate = useNavigate();
  
  // 設置頁面標題
  useEffect(() => {
    document.title = '找不到頁面 - 404';
  }, []);

  return (
    <div className="forbidden-container">
      <div className="forbidden-content">
        <div className="forbidden-header">
          <h2>找不到頁面 (404)</h2>
        </div>
        
        <div className="forbidden-body">
          <Alert variant="warning" className="mb-4">
            <Alert.Heading>抱歉，找不到您要瀏覽的頁面</Alert.Heading>
            <p>
              您嘗試瀏覽的頁面不存在或已被移除。請檢查網址是否正確，或使用下方按鈕返回首頁。
            </p>
          </Alert>

          <div className="forbidden-animation">
            <div className="animation-wrapper">
              <img 
                src="/images/jpg/asuka.jpg"
                alt="頁面未找到"
                className="forbidden-image"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.style.display = 'none';
                }}
              />
            </div>
            <p className="animation-caption">看起來您迷路了...</p>
          </div>

          <div className="forbidden-actions">
            <Button 
              variant="primary" 
              size="lg" 
              onClick={() => navigate('/')}
            >
              返回首頁
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;